import { Carousel } from '@liveauctioneers/hammer-ui-core/carousel';
import { useMemo } from 'react';

import CarouselLoadingWrapper from '@/components/CarouselLoadingWrapper/CarouselLoadingWrapper';
import { FeaturedAuctioneer } from '@/redux/modules/home/home.types';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

import { AuctioneerCard } from './AuctioneerCard';

type FeaturedAuctioneersCarouselProps = {
    featuredAuctioneers: FeaturedAuctioneer[];
};

export const FeaturedAuctioneersCarousel = ({ featuredAuctioneers }: FeaturedAuctioneersCarouselProps) => {
    const formatMessage = useAppFormatMessage();

    const carouselCards = useMemo(
        () =>
            featuredAuctioneers.map(({ destinationURL, featuredAuctioneerId, houseId, houseName, imageURL }) => ({
                card: (
                    <AuctioneerCard
                        destinationURL={destinationURL}
                        featuredAuctioneerId={featuredAuctioneerId}
                        houseId={houseId}
                        houseName={houseName}
                        imageURL={imageURL}
                        key={`${featuredAuctioneerId}-${houseId}`}
                    />
                ),
                key: `${featuredAuctioneerId}-${houseId}`,
            })),
        [featuredAuctioneers]
    );

    return (
        // 1200 = caterwaul's old theme.breakpoints.pageWidthNum (1240) minus 40 — no hammer-ui token matches exactly.
        <CarouselLoadingWrapper className="mx-auto w-[calc(100%-40px)] max-w-[1200px]">
            <Carousel
                cards={carouselCards}
                title={String(formatMessage(['featuredAuctioneers', 'featured']))}
            />
        </CarouselLoadingWrapper>
    );
};
